import React from "react";
import { Tabs, Radio, Row, Col,Tooltip } from "antd";
// import ZenClusterColumnVer from "../ManagerDashboard/Common/Graph/ZenClusterColumnVer";
// import ZenVerStackBar from"../ManagerDashboard/Common/Graph/ZenVerStackBar";
import ZenContainerAngela from"../ManagerDashboard/Common/Containers/ZenContainerAngela";
import Angela from"../ManagerDashboard/Common/DataCard/Angela";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
// import { Col, Row, Tooltip } from "antd";
import { NavLink, useHistory } from "react-router-dom";

class SbLineDoh extends React.Component {
  state = {
    // ZenClusterColumnVer: null,
    // ZenVerStackBar: null,
    loading: true,
    loginError: false,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    // this.state.plant_landing_page.setPageHeader("Dashboard");
    this._isMounted = true;
    this.fetchTrendData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      // .get("/sb/dashboard/chartdata", {
      //   typ: "plant_landing_page"
      // })
      .get("/sb/dashboard/chartdata", this.props.urlData || {})
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["plant_landing_page"] = resp["data"]["plant_landing_page"];
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  
  render() {
    if (this.state.mainData) {
      return (
<div>
<Row style={{   background: "#000000"}} >
            <Col span={10}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <Angela
                divId={this.state.respData.angela1.divId || "Angela1"}
                data={this.state.respData.angela1.data}
                config={this.state.respData.angela1.config}
              />
              </div>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenContainerAngela
                  divId={"R2C2"}
                  // respData = {this.state.ZenVerBarChart}
                  // data={this.state.TopVariationD2.data}
                  // config={this.state.TopVariationD2.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>



              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                 <Angela
                divId={this.props.divId || "Angela1"}
                data={this.state.mainData.data}
                config={this.state.mainData.config}
              />
              </div>



            </Col>
            <Col span={14}>
             
            </Col>
           
            
 
           
          </Row>


</div>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default SbLineDoh;
